import {
  Box,
  Chip,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { BarChart, ExpandMore, MoreVert, Search, Visibility } from '@material-ui/icons';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { brazilianDateFormat } from '../../../../utils/date-formatter.util';
import ApplicationResource from '../../../../utils/resources.enum';
import { AssessmentStatusChip } from './status-chip';
import { useStyles } from './styles';

const VIGENCY_TABS = [
  { value: true, label: 'Disponíveis' },
  { value: false, label: 'Encerradas' },
];

export function QuizAssessmentsTable({
  records,
  total,
  page,
  perPage,
  onPageChange,
  onPerPageChange,
  vigentFilter,
  onVigentFilterChange,
  loading,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [search, setSearch] = useState('');
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);

  // Full-text search across all pages requires backend support; for now this
  // only filters the records already loaded for the current page.
  const filteredRecords = records.filter((record) =>
    (record.name || '').toLowerCase().includes(search.toLowerCase())
  );

  const goToResults = (id) =>
    history.push(`/${ApplicationResource.QUIZ_ASSESSMENT_AVAILABILITY}/results/${id}`);
  const goToEdit = (id) =>
    history.push(`/${ApplicationResource.QUIZ_ASSESSMENT_AVAILABILITY}/${id}`);

  return (
    <Paper>
      <Box className={classes.tableToolbar}>
        <Box className={classes.tableTabs}>
          {VIGENCY_TABS.map(({ value, label }) => (
            <Chip
              key={String(value)}
              label={label}
              onClick={() => onVigentFilterChange(value)}
              color={vigentFilter === value ? 'primary' : 'default'}
              variant={vigentFilter === value ? 'default' : 'outlined'}
              className={classes.filterChip}
            />
          ))}
        </Box>

        {/*<Box className={classes.tableToolbarActions}>*/}
        {/*  <TextField*/}
        {/*    size="small"*/}
        {/*    variant="outlined"*/}
        {/*    placeholder="Buscar avaliações..."*/}
        {/*    value={search}*/}
        {/*    onChange={(event) => setSearch(event.target.value)}*/}
        {/*    InputProps={{*/}
        {/*      startAdornment: (*/}
        {/*        <InputAdornment position="start">*/}
        {/*          <Search fontSize="small" />*/}
        {/*        </InputAdornment>*/}
        {/*      ),*/}
        {/*    }}*/}
        {/*  />*/}
        {/*  <Box*/}
        {/*    className={classes.filtersButton}*/}
        {/*    onClick={(event) => setFiltersAnchorEl(event.currentTarget)}*/}
        {/*  >*/}
        {/*    <Typography variant="body2" className={classes.filtersButtonLabel}>*/}
        {/*      Filtros*/}
        {/*    </Typography>*/}
        {/*    <ExpandMore fontSize="small" />*/}
        {/*  </Box>*/}
        {/*  <Menu*/}
        {/*    anchorEl={filtersAnchorEl}*/}
        {/*    open={Boolean(filtersAnchorEl)}*/}
        {/*    onClose={() => setFiltersAnchorEl(null)}*/}
        {/*  >*/}
        {/*    <MenuItem disabled>Mais filtros em breve</MenuItem>*/}
        {/*  </Menu>*/}
        {/*</Box>*/}
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Avaliações</TableCell>
            <TableCell>Turma</TableCell>
            <TableCell>Qtd. de Questões</TableCell>
            <TableCell>Data de Início</TableCell>
            <TableCell>Data de Fim</TableCell>
            {/*<TableCell>Realizados</TableCell>*/}
            {/*<TableCell>Não Realizados</TableCell>*/}
            <TableCell>Status</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredRecords.map((record) => (
            <TableRow key={record.id}>
              <TableCell>{record.name}</TableCell>
              <TableCell>{record.classes?.map((c) => c.name).join(', ')}</TableCell>
              <TableCell>{record.questionAmount}</TableCell>
              <TableCell>{brazilianDateFormat(record.start)}</TableCell>
              <TableCell>{brazilianDateFormat(record.end)}</TableCell>
              {/*/!* Realizados/Não Realizados require a participation-count endpoint not yet available *!/*/}
              {/*<TableCell>-</TableCell>*/}
              {/*<TableCell>-</TableCell>*/}
              <TableCell>
                <AssessmentStatusChip record={record} />
              </TableCell>
              <TableCell>
                <Box className={classes.rowActions}>
                  <Tooltip title="Visualizar">
                    <IconButton size="small" onClick={() => goToEdit(record.id)}>
                      <Visibility fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Ver desempenho">
                    <IconButton size="small" onClick={() => goToResults(record.id)}>
                      <BarChart fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  {/*<RowActionsMenu onEdit={() => goToEdit(record.id)} />*/}
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {!loading && filteredRecords.length === 0 && (
            <TableRow>
              <TableCell colSpan={9} align="center">
                Nenhuma avaliação encontrada
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={total || 0}
        page={page - 1}
        rowsPerPage={perPage}
        onChangePage={(_, newPage) => onPageChange(newPage + 1)}
        onChangeRowsPerPage={(event) => onPerPageChange(parseInt(event.target.value, 10))}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Linhas por página"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export function RowActionsMenu({ onEdit }) {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <IconButton size="small" onClick={(event) => setAnchorEl(event.currentTarget)}>
        <MoreVert fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onEdit();
          }}
        >
          Editar
        </MenuItem>
      </Menu>
    </>
  );
}